export default __webpack_public_path__ + "static/media/champSelect.7b0084c0.png";